import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { WeeklyReviewNotesInput } from 'shared';

import { regenerateWeeklyReview, updateWeeklyReviewNotes } from '../../lib/api/endpoints';

import { reviewKeys } from './queries';

export function useRegenerateWeeklyReview() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: regenerateWeeklyReview,
    onSuccess: (review) => {
      queryClient.setQueryData(reviewKeys.weeklyDetail(review.weekStart), review);
      void queryClient.invalidateQueries({ queryKey: reviewKeys.weekly() });
    },
  });
}

export function useUpdateWeeklyReviewNotes() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { weekStart: string; body: WeeklyReviewNotesInput }) =>
      updateWeeklyReviewNotes(input),
    onSuccess: (review) => {
      queryClient.setQueryData(reviewKeys.weeklyDetail(review.weekStart), review);
      void queryClient.invalidateQueries({ queryKey: reviewKeys.weekly() });
    },
  });
}
